import { RolePermission } from "@/@types/app/RolePermission";
import { appApi } from "../api";
export async function getProfilePermissionsByProfileId(roleId: number) {
	const { data } = await appApi.get<RolePermission[]>(`/profilepermission/role/${roleId}`);
	return data || [];
}

export async function registerProfilePermission(roleId: number, permissionId: number) {
	const response = await appApi.post(`/profilepermission`, {
		roleId,
		permissionId,
	});
	return response.status === 200;
}

export async function deleteProfilePermission(roleId: number, permissionId: number) {
	const response = await appApi.post(`/profilepermission/delete`, {
		roleId,
		permissionId,
	});
	return response.status === 200;
}
